import styles from './preview.module.scss';
import parse from 'html-react-parser';
import Image from 'next/image';
import { Themes } from '@layouts/main-layout/themes.enum';
import Breadcrumbs from '@components/shared/miscellaneous/breadcrumbs/breadcrumbs';
import { techDueDiligenceState } from '@components/tech-due-diligence/tech-due-diligence.state';
import TechDueDiligenceQuiz from './tech-due-diligence-quiz';

type PreviewProps = {
  formId: string;
  lastElementTitle: string;
  isDifferentColor?: boolean;
  isCustomzePhoto?: boolean;
};

const PreviewGreenSection = ({ formId, lastElementTitle }: PreviewProps) => {
  const { title, description, assessTitle, badge, checklist, checkIconUrl } = techDueDiligenceState.hero;

  return (
    <section className={styles.section}>
      <div className={styles.section__wrapper}>
        <Breadcrumbs lastElementTitle={lastElementTitle} theme={Themes.White} />
        <div className={styles.section__block}>
          <div className={styles.section__block__wrapper}>
            <h1 className={styles.section__title}>{parse(title)}</h1>
            <div className={styles.section__text}>{parse(description)}</div>
            <div className={styles.section__assess}>
              <div className={styles.section__assess__header}>
                <div className={styles.section__assess__header__title}>{assessTitle}</div>
                <div className={styles.section__assess__header__description}>{badge}</div>
              </div>
              <div className={styles.section__assess__list}>
                {checklist.map((item) => (
                  <div className={styles.section__assess__list__item} key={item}>
                    <div className={styles.section__assess__list__item__icon}>
                      <Image src={checkIconUrl} alt="" width={26} height={26} />
                    </div>
                    <div className={styles.section__assess__list__item__text}>{item}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className={styles.section__block__form} id={formId}>
            <TechDueDiligenceQuiz />
          </div>
        </div>
      </div>
    </section>
  );
};

export default PreviewGreenSection;
